<template>
  <button
    type="button"
    class="btn btn-sm btn-filter-followup"
    :class="isActive ? 'btn-primary' : 'btn-outline-secondary'"
    @click="$emit('input', !isActive)"
  >
    <i class="fa mr-1" :class="isActive ? 'fa-check-square' : 'fa-square-o'"></i>
    <slot />
  </button>
</template>

<script>
export default {
  name: 'filter-toggle-button',
  props: {
    value: { type: Boolean, default: false },
  },
  computed: {
    isActive() {
      return !!this.value;
    },
  },
};
</script>

<style scoped>
button {
  white-space: nowrap;
}

.btn-filter-followup {
    border: 0px;
    font-size: 1em;
    color: #444;
    padding: 0;
    line-height: 2.7em !important;
    background: transparent !important;
}

.btn-filter-followup:hover {
    color: #444 !important;
    background: transparent !important;
}
</style>
